var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 95.57 91.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3,.cls-4{fill:none;stroke:#ff4500;stroke-miterlimit:10;}.cls-1{stroke-width:2.66px;}.cls-2{fill:#ff4500;}.cls-3{stroke-width:3.04px;}.cls-4{stroke-width:1.71px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.69,40.94V60.35A29.65,29.65,0,0,1,41,90H11.31a10,10,0,0,1-10-10V25.88a10,10,0,0,1,10-10H54.45"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1.33,
    y1: 35.63,
    x2: 60.98,
    y2: 35.63
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.69,52.14v2.07a6.64,6.64,0,0,1-6.63,6.66c-4.71,0-10.89,1.07-15,6.06a29.47,29.47,0,0,0-6.73,14.88A9.45,9.45,0,0,1,33,90h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.44,23.38H19.69V20.61h9.65v2.77h-2.7v7.75h-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.42,20.61h4.23v3.75h1.86V20.61h4.23V31.13H36.51v-4H34.65v4H30.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.52,20.61v6.86c0,.76.33,1.16,1,1.16s.88-.46.88-1.16V20.61h4.24v6.2c0,3.23-1.9,4.59-5.21,4.59s-5.11-1.48-5.11-4.6V20.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M42.38,78.89c.1-.43.12-1.09.25-1.52a28.07,28.07,0,0,1,1.92-4.73c.6-1.15.4-1.49,1.17-2.55V40.94H34.78a13.3,13.3,0,0,1-8.49,4v8.54a19.05,19.05,0,0,0,3.9.63V78.89Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 75.76,
    cy: 19.8,
    r: 18.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 75.76,
    y1: 8.99,
    x2: 75.76,
    y2: 4.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 75.76,
    y1: 34.43,
    x2: 75.76,
    y2: 30.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 86.42,
    y1: 19.65,
    x2: 90.54,
    y2: 19.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 60.98,
    y1: 19.65,
    x2: 65.1,
    y2: 19.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 75.76,
    y1: 25.25,
    x2: 75.76,
    y2: 19.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 75.76,
    y1: 19.8,
    x2: 65.82,
    y2: 12.91
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 75.76,
    cy: 19.65,
    r: 1.73
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/icon-calendar.4c8aa27e74c767368c11329bbd87408e.svg";
export { ForwardRef as ReactComponent };